<template>
  <form>
    <AnthropometricEvaluationSimpleForm
      v-bind:idAppointment="this.$props.idAppointment"
      @AnthropometricEvaluationChanged="get()"/> 

    <div id="div-other-infos" class="vs-con-loading__container">
      <vx-card title="Histórico">
        <div slot="no-body" class="mt-4">
          <vs-table :data="anthropometricEvaluations">
            <template slot="thead">
              <vs-th>Data</vs-th>
              <vs-th>Peso (Kg)</vs-th>
              <vs-th>Estatura (cm)</vs-th>
              <vs-th>IMC</vs-th>
              <vs-th>ZScore P/I</vs-th>
              <vs-th>ZScore E/I</vs-th>
              <vs-th>ZScore P/E</vs-th>
              <vs-th>ZScore IMC</vs-th>
              <vs-th>Classificação Peso</vs-th>
              <vs-th>Classificação Estatura</vs-th>
            </template>

            <template slot-scope="{data}">
              <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                <vs-td :data="data[indextr].id">
                  <span>{{data[indextr].calculatedDate.substring(0, 10)}}</span>
                </vs-td>
                <vs-td :data="data[indextr].id">
                  <span>{{data[indextr].weightInKg}}</span>
                </vs-td>
                <vs-td :data="data[indextr].id">
                  <span>{{data[indextr].heightOrLengthInCentimeter}}</span>
                </vs-td>
                <vs-td :data="data[indextr].id">
                  <span>{{data[indextr].bodyMassIndex}}</span>
                </vs-td>
                <vs-td :data="data[indextr].status">
                  <span>{{data[indextr].zScoreWeightForAge}}</span>
                </vs-td>
                <vs-td :data="data[indextr].id">
                  <span>{{data[indextr].zScoreLengthOrHeightForAge}}</span>
                </vs-td>
                <vs-td :data="data[indextr].id">
                  <span>{{data[indextr].zScoreWeightForLengthOrHeight}}</span>
                </vs-td>
                <vs-td :data="data[indextr].id">
                  <span>{{data[indextr].zScoreBodyMassIndex}}</span>
                </vs-td>
                <vs-td :data="data[indextr].id">
                  <span>{{data[indextr].weightClassificationType}}</span>
                </vs-td>
                <vs-td :data="data[indextr].id">
                  <span>{{data[indextr].heightClassificationType}}</span>
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </div>
      </vx-card>
    </div>
  </form>
</template>

<script>
import AnthropometricEvaluationService from "../../../services/AnthropometricEvaluationService";
import AnthropometricEvaluationSimpleForm from "../appointment/anthropometricEvaluation/AnthropometricEvaluationSimpleForm";

export default {
  components: {
    AnthropometricEvaluationSimpleForm
  },
  props: {
    idAppointment: {
      // type: Number,
      required: true
    },
    idPatient: {
      // type: Number,
      required: true
    }
  },
  data() {
    return {
      data: {
        id: 0,
        idAppointment: 0,
        idPatient: 0,
        bowelHabits: "",
        nausea: false,
        vomiting: false,
        physicalActivity: "",
        medicines: "",
        supplements: "",
        multivitamins: ""
      },
      anthropometricEvaluations: [],
      notifications: {
        notify: this.$vs.notify,
        dialog: this.$vs.dialog,
        errors: this.errors,
        showSucces: false,
        showError: true
      },
      defaultDivId: "div-other-infos"
    };
  },
  mounted: function() {
    this.data.idPatient = this.$props.idPatient;
    this.data.idAppointment = this.$props.idAppointment;
    this.get();
  },
  methods: {
    async submit() {
      console.log(this.data.id);
      if (this.data.id != null && this.data.id > 0) {
        this.update();
      } else {
        this.create();
      }
    },
    async get() {
      console.log("get", this.data.idPatient);
      this.openLoadingInDiv(this.defaultDivId);

      const payload = {
        data: {
          idPatient: this.data.idPatient
        },
        notifications: this.notifications
      };

      payload.notifications.showSucces = false;
      payload.notifications.showError = false;

      var result = await AnthropometricEvaluationService.getByPatientId(payload);
      console.log(result);
      if (result.status == 200) {
        if (result.data.result != null) {
          this.anthropometricEvaluations = result.data.result;
        }
      }

      this.closeLoadingDiv(this.defaultDivId);
    },
    async create() {
      this.openLoadingInDiv(this.defaultDivId);

      const payload = {
        data: this.data,
        notifications: this.notifications
      };

      console.log(payload);

      payload.notifications.showSucces = true;
      payload.notifications.showError = true;

      await AnthropometricEvaluationService.create(payload);

      this.closeLoadingDiv(this.defaultDivId);
    },
    async update() {
      this.openLoadingInDiv(this.defaultDivId);

      const payload = {
        data: this.data,
        notifications: this.notifications
      };

      payload.notifications.showSucces = true;
      payload.notifications.showError = true;

      await AnthropometricEvaluationService.update(payload);

      this.closeLoadingDiv(this.defaultDivId);
    },
    openLoadingInDiv(divId) {
      this.$vs.loading({
        container: "#" + divId,
        scale: 0.6
      });
    },
    closeLoadingDiv(divId) {
      this.$vs.loading.close("#" + divId + " > .con-vs-loading");
    }
  }
};
</script>

<style scoped>
.label {
  padding-left: 5px;
  font-size: 0.85rem;
  color: rgba(0, 0, 0, 0.7);
}
</style>